import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import React from 'react';

import { useAppContext } from '../hooks/AppProvider';
import { trackEvent } from '../modules/matomo';

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  marginLeft: theme.spacing(0),
  fontSize: '1.75rem',
  color: theme.palette.text.primary,
  svg: {
    transform: 'scale(0.9)',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '3rem',
  },
}));

const ThemeToggleButton = () => {
  const { colorMode, mode } = useAppContext();
  const darkMode = mode === 'dark';
  return (
    <Tooltip title={darkMode ? "Wechsel zu hellem Modus" : "Wechsel zu dunklem Modus"}>
      <StyledIconButton
        aria-label={darkMode ? 'Zum hellen Farbschema wechseln' : 'Zum dunklen Farbschema wechseln'}
        className="borderBox"
        onClick={() => {
          colorMode.toggleColorMode();
          trackEvent('Theme', `Toggle ${darkMode ? 'Light' : 'Dark'} Mode`, 'Header');
        }}
      >
        {darkMode ? <Brightness7Icon fontSize="inherit" /> : <Brightness4Icon fontSize="inherit" />}
      </StyledIconButton>
    </Tooltip>
  );
};

export default ThemeToggleButton;
